import React from 'react';

export function BellSvgIcon () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      fill="none"
      viewBox="0 0 38 38"
    >
      <circle cx="19" cy="19" r="19" fill="#EEF9F8" />
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 26.5c.486 1.475 2.224 2.32 3.88 1.887 1.022-.267 1.82-.978 2.12-1.887M19 12.125V9.5M19 12.333a5.556 5.556 0 015.556 5.556c0 5.22 1.944 6.61 1.944 6.61h-15s1.945-1.918 1.945-6.61A5.556 5.556 0 0119 12.333z"
      />
    </svg>
  );
}
